import {API} from './API.js';
import {SACodeSelector as _SACodeSelector} from './SACodeSelector.js';
import {SACodeDetails as _SACodeDetails} from './SACodeDetails.js';
import {SACodeDisplay as _SACodeDisplay} from './SACodeDisplay.js';

export class SAFire {
	constructor() {

	}
	static API() {
		return new API(SAFire.origin);
	}
}
(function() {
	SAFire.script = document.currentScript;
	const u = URL.parse(SAFire.script.getAttribute("src"), document.URL);
	SAFire.origin = u.origin;
})();
document.addEventListener(`DOMContentLoaded`, ()=>{ new SAFire(); });